import { render, staticRenderFns } from "./Mediatendency.vue?vue&type=template&id=daf0718c&"
import script from "./Mediatendency.vue?vue&type=script&lang=js&"
export * from "./Mediatendency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports